import React from 'react';
import './PC.css';
import Adobe from '../../img/pc/Adobe.png'
import Goldberg from '../../img/pc/Goldberg.png'
import Hawkins from '../../img/pc/Hawkins.png'
import m4dz from '../../img/pc/m4dz.png'
import Maggiore from '../../img/pc/Maggiore.png'

export default class PC extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      speakers: [
        {
          photo: Maggiore,
          name: 'Giuseppe Maggiore',
          position: 'CTO @Hoppinger',
          ln: 'https://www.linkedin.com/in/giuseppemaggiore/',
        },
        {
          photo: Hawkins,
          name: 'Tyler Hawkins',
          position: 'Senior Software Engineer',
          ln: 'https://www.linkedin.com/in/tyler-hawkins-2b147513b/',
          tw: 'https://twitter.com/thawkin3',
          website: 'https://medium.com/@thawkin3',
          logo: Adobe,
        },
        {
          photo: m4dz,
          name: 'm4dz 🎙🥑',
          position: 'Frontend Devtools Advocate',
          ln: 'https://www.linkedin.com/in/m4d-z/',
          tw: 'https://twitter.com/m4d_z',
        },
        {
          photo: Goldberg,
          name: 'Josh Goldberg',
          position: 'Open Source Developer',
          github: 'https://github.com/JoshuaKGoldberg',
          website: 'https://twitch.tv/JoshuaKGoldberg',
        },
      ],
    }
  }

  renderPC(item, i) {
    return (
      <div className="pc_item" key={`team-${i}`}>
        <div className='pc_info' style={{ backgroundImage: `url(${item.photo}` }}>
          <p className="pc_name p1">{item.name}</p>
          <p className="pc_position p2 grey">{item.position}</p>
          <img className='pc_logo' src={item.logo} alt="" />
          <div className="pc_links">
            {item.fb && <a className="social_link social_fb" target='_blank' rel="noreferrer" href={item.fb}></a>}
            {item.ln && <a className="social_link social_ln" target='_blank' rel="noreferrer" href={item.ln}></a>}
            {item.tw && <a className="social_link social_tw" target='_blank' rel="noreferrer" href={item.tw}></a>}
            {item.github && <a className="social_link social_github" target='_blank' rel="noreferrer" href={item.github}></a>}
            {item.website && <a className="social_link social_website" target='_blank' rel="noreferrer" href={item.website}></a>}
            {item.youtube && <a className="social_link social_yb" target='_blank' rel="noreferrer" href={item.youtube}></a>}
            {item.twitch && <a className="social_link social_twitch" target='_blank' rel="noreferrer" href={item.twitch}></a>}
          </div>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="pc_wrap pc_wrap--mb" id='pc'>
        <div className='container pc'>
          <h2 className='pc_title pc_main'>&lt;Program <span className='title_gradient'>committee</span>&gt;</h2>
          <div className='pc_block'>
            {this.state.speakers.map((item, i) => this.renderPC(item, i))}
          </div>
        </div>
      </div>
    )
  }
}